import { useState, useEffect } from 'react';
import { supabase } from '../supabase';
import { useAuth } from '../contexts/AuthContext';

function Admin() {
  const { usuario } = useAuth();
  const [membros, setMembros] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [modalNovo, setModalNovo] = useState(false);
  const [novoMembro, setNovoMembro] = useState({ nome: '', email: '', senha: '', role: 'membro', modulo_ads: false, modulo_social: false });
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');
  const [mostrarSenha, setMostrarSenha] = useState(false);

  useEffect(() => { carregarMembros(); }, []);

  const carregarMembros = async () => {
    const { data } = await supabase.from('usuarios').select('*').order('nome');
    setMembros(data || []);
    setCarregando(false);
  };

  const toggleAtivo = async (membro) => {
    const novoRole = membro.role === 'inativo' ? 'membro' : 'inativo';
    await supabase.from('usuarios').update({ role: novoRole }).eq('id', membro.id);
    carregarMembros();
  };

  const atualizarRole = async (id, role) => {
    await supabase.from('usuarios').update({ role }).eq('id', id);
    carregarMembros();
  };

  const atualizarModulos = async (id, campo, valor) => {
    await supabase.from('usuarios').update({ [campo]: valor }).eq('id', id);
    carregarMembros();
  };

  const criarMembro = async () => {
  if (!novoMembro.nome || !novoMembro.email || !novoMembro.senha) {
    setErro('Preencha nome, email e senha.');
    return;
  }
  setSalvando(true);
  setErro('');

  const { data: { session } } = await supabase.auth.getSession();

  const response = await fetch(
    'https://pofhtqmbmtuztrafrwyz.supabase.co/functions/v1/criar-usuario',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`,
      },
      body: JSON.stringify({
        nome: novoMembro.nome,
        email: novoMembro.email,
        senha: novoMembro.senha,
        role: novoMembro.role,
        modulo_ads: novoMembro.modulo_ads,
        modulo_social: novoMembro.modulo_social,
      }),
    }
  );

  const result = await response.json();

  if (result.error) {
    setErro(result.error);
    setSalvando(false);
    return;
  }

  setModalNovo(false);
  setNovoMembro({ nome: '', email: '', senha: '', role: 'membro', modulo_ads: false, modulo_social: false });
  setSalvando(false);
  carregarMembros();
};

  const getRoleBadge = (role) => {
    if (role === 'admin') return { label: 'Admin', bg: '#2a2a00', color: '#DCF127' };
    if (role === 'inativo') return { label: 'Inativo', bg: '#2a0a0a', color: '#ef4444' };
    return { label: 'Membro', bg: '#1a1a2a', color: '#818cf8' };
  };

  if (!usuario || usuario.role !== 'admin') {
    return (
      <div className="flex items-center justify-center h-64">
        <p style={{ color: '#555' }}>Acesso restrito a administradores.</p>
      </div>
    );
  }

  if (carregando) return <div className="flex items-center justify-center h-64"><p style={{ color: '#555' }}>Carregando...</p></div>;

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-white">Administração</h1>
          <p className="text-sm mt-1" style={{ color: '#555' }}>Gerencie os membros e acessos do time</p>
        </div>
        <button onClick={() => setModalNovo(true)}
          className="text-sm px-4 py-2 rounded-lg font-medium"
          style={{ backgroundColor: '#DCF127', color: '#0a0a0a' }}>
          + Novo membro
        </button>
      </div>

      {/* Lista de membros */}
      <div className="rounded-xl overflow-hidden" style={{ border: '1px solid #1a1a1a' }}>
        <div className="px-4 py-3" style={{ backgroundColor: '#111', borderBottom: '1px solid #1a1a1a' }}>
          <p className="text-xs font-medium uppercase tracking-wide" style={{ color: '#555' }}>
            {membros.length} membros
          </p>
        </div>
        {membros.map((membro, i) => {
          const badge = getRoleBadge(membro.role);
          const isInativo = membro.role === 'inativo';
          const isSelf = membro.id === usuario.id;
          return (
            <div key={membro.id}
              className="flex items-center gap-4 px-4 py-4"
              style={{
                backgroundColor: '#111',
                borderBottom: i < membros.length - 1 ? '1px solid #1a1a1a' : 'none',
                opacity: isInativo ? 0.5 : 1,
              }}>

              {/* Avatar */}
              <div className="w-9 h-9 rounded-full flex items-center justify-center text-sm font-semibold flex-shrink-0"
                style={{ backgroundColor: '#1a1a1a', color: '#DCF127' }}>
                {membro.nome?.charAt(0).toUpperCase()}
              </div>

              {/* Info */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-medium text-white">{membro.nome}</p>
                  {isSelf && <span className="text-xs" style={{ color: '#555' }}>(você)</span>}
                </div>
                <p className="text-xs" style={{ color: '#555' }}>{membro.email}</p>
              </div>

              {/* Role badge */}
              <span className="text-xs px-2 py-1 rounded-full font-medium"
                style={{ backgroundColor: badge.bg, color: badge.color }}>
                {badge.label}
              </span>

              {/* Módulos — só pra membros */}
              {membro.role === 'membro' && (
                <div className="flex gap-2">
                  <button
                    onClick={() => atualizarModulos(membro.id, 'modulo_ads', !membro.modulo_ads)}
                    className="text-xs px-2 py-1 rounded transition-all"
                    style={{
                      backgroundColor: membro.modulo_ads ? '#E6F1FB' : '#1a1a1a',
                      color: membro.modulo_ads ? '#185FA5' : '#444',
                      border: membro.modulo_ads ? 'none' : '1px solid #222',
                    }}>
                    Ads
                  </button>
                  <button
                    onClick={() => atualizarModulos(membro.id, 'modulo_social', !membro.modulo_social)}
                    className="text-xs px-2 py-1 rounded transition-all"
                    style={{
                      backgroundColor: membro.modulo_social ? '#EAF3DE' : '#1a1a1a',
                      color: membro.modulo_social ? '#3B6D11' : '#444',
                      border: membro.modulo_social ? 'none' : '1px solid #222',
                    }}>
                    Social
                  </button>
                </div>
              )}

              {/* Role selector — não deixa mudar o próprio */}
              {!isSelf && (
                <select
                  value={membro.role === 'inativo' ? 'inativo' : membro.role}
                  onChange={(e) => atualizarRole(membro.id, e.target.value)}
                  className="text-xs px-2 py-1.5 rounded-lg outline-none"
                  style={{ backgroundColor: '#1a1a1a', border: '1px solid #222', color: '#aaa' }}>
                  <option value="admin">Admin</option>
                  <option value="membro">Membro</option>
                  <option value="inativo">Inativo</option>
                </select>
              )}

              {/* Toggle ativo/inativo */}
              {!isSelf && (
                <button
                  onClick={() => toggleAtivo(membro)}
                  className="relative w-9 h-5 rounded-full transition-all flex-shrink-0"
                  style={{ backgroundColor: !isInativo ? '#DCF127' : '#333' }}>
                  <div className="absolute w-3.5 h-3.5 rounded-full bg-white top-0.5 transition-all"
                    style={{ left: !isInativo ? '20px' : '3px' }} />
                </button>
              )}
            </div>
          );
        })}
      </div>

      {/* Modal novo membro */}
      {modalNovo && (
        <div className="fixed inset-0 flex items-center justify-center z-50"
          style={{ backgroundColor: 'rgba(0,0,0,0.7)' }}
          onClick={() => setModalNovo(false)}>
          <div className="rounded-2xl p-6 w-full max-w-md"
            style={{ backgroundColor: '#111', border: '1px solid #333' }}
            onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-5">
              <h2 className="text-base font-semibold text-white">Novo membro</h2>
              <button onClick={() => setModalNovo(false)} style={{ color: '#555' }} className="text-lg hover:text-white">✕</button>
            </div>

            <div className="flex flex-col gap-3 mb-4">
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Nome</label>
                <input type="text" value={novoMembro.nome}
                  onChange={(e) => setNovoMembro({ ...novoMembro, nome: e.target.value })}
                  placeholder="Nome completo"
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white"
                  style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }} />
              </div>
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Email</label>
                <input type="email" value={novoMembro.email}
                  onChange={(e) => setNovoMembro({ ...novoMembro, email: e.target.value })}
                  placeholder="email@exemplo.com"
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white"
                  style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }} />
              </div>
           <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Senha inicial</label>
                <div className="relative">
                    <input
                    type={mostrarSenha ? 'text' : 'password'}
                    value={novoMembro.senha}
                    onChange={(e) => setNovoMembro({ ...novoMembro, senha: e.target.value })}
                    placeholder="mínimo 6 caracteres"
                    className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white"
                    style={{ backgroundColor: '#1a1a1a', border: '1px solid #333', paddingRight: '40px' }}
                    />
                    <button
                    type="button"
                    onClick={() => setMostrarSenha(!mostrarSenha)}
                    className="absolute right-3 top-2 text-xs"
                    style={{ color: '#555' }}>
                    {mostrarSenha ? '🙈' : '👁'}
                    </button>
                </div>
                </div>
              <div>
                <label className="text-xs mb-1 block" style={{ color: '#555' }}>Role</label>
                <select value={novoMembro.role}
                  onChange={(e) => setNovoMembro({ ...novoMembro, role: e.target.value })}
                  className="w-full text-sm px-3 py-2 rounded-lg outline-none text-white"
                  style={{ backgroundColor: '#1a1a1a', border: '1px solid #333' }}>
                  <option value="admin">Admin</option>
                  <option value="membro">Membro</option>
                </select>
              </div>

              {novoMembro.role === 'membro' && (
                <div className="rounded-lg p-3" style={{ backgroundColor: '#1a1a1a', border: '1px solid #222' }}>
                  <p className="text-xs mb-2" style={{ color: '#555' }}>Módulos com acesso</p>
                  <div className="flex gap-3">
                    {[
                      { campo: 'modulo_ads', label: 'Ads' },
                      { campo: 'modulo_social', label: 'Social Media' },
                    ].map(({ campo, label }) => (
                      <button key={campo}
                        onClick={() => setNovoMembro({ ...novoMembro, [campo]: !novoMembro[campo] })}
                        className="flex items-center gap-2 text-sm transition-all"
                        style={{ color: novoMembro[campo] ? '#fff' : '#555' }}>
                        <div className="relative w-8 h-5 rounded-full transition-all"
                          style={{ backgroundColor: novoMembro[campo] ? '#DCF127' : '#333' }}>
                          <div className="absolute w-3 h-3 rounded-full bg-white top-1 transition-all"
                            style={{ left: novoMembro[campo] ? '18px' : '3px' }} />
                        </div>
                        {label}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {erro && <p className="text-xs" style={{ color: '#ef4444' }}>{erro}</p>}
            </div>

            <div className="flex gap-2">
              <button onClick={() => setModalNovo(false)}
                className="flex-1 py-2 rounded-lg text-sm"
                style={{ backgroundColor: '#1a1a1a', color: '#aaa' }}>
                Cancelar
              </button>
              <button onClick={criarMembro} disabled={salvando}
                className="flex-1 py-2 rounded-lg text-sm font-medium"
                style={{ backgroundColor: '#DCF127', color: '#0a0a0a', opacity: salvando ? 0.7 : 1 }}>
                {salvando ? 'Criando...' : 'Criar membro'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Admin;